import { render, staticRenderFns } from "./TabDenominacionSocial.vue?vue&type=template&id=7cf02304"
import script from "./TabDenominacionSocial.vue?vue&type=script&lang=js"
export * from "./TabDenominacionSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cf02304')) {
      api.createRecord('7cf02304', component.options)
    } else {
      api.reload('7cf02304', component.options)
    }
    module.hot.accept("./TabDenominacionSocial.vue?vue&type=template&id=7cf02304", function () {
      api.rerender('7cf02304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/constitucionsociedades/TabDenominacionSocial.vue"
export default component.exports